import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
var _excluded = ["onSearch", "className"];
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var _context, _context2; var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? _forEachInstanceProperty(_context = ownKeys(Object(t), !0)).call(_context, function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : _forEachInstanceProperty(_context2 = ownKeys(Object(t))).call(_context2, function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from "react";
import classNames from "classnames";
import { TextField } from "components/mui/Fields";
import { Icon, makeStyles, RaiseColors } from "componentLibrary";
import { jsx as _jsx } from "react/jsx-runtime";
var useStyles = makeStyles(function () {
  return {
    searchField: {
      "& > div": {
        border: "none",
        borderBottom: "1px solid ".concat(RaiseColors.gray300),
        borderRadius: 0,
        fontSize: 14,
        height: 34,
        marginRight: 18
      }
    },
    searchIcon: {
      fontSize: "14px",
      color: RaiseColors.gray300,
      overflow: "visible"
    }
  };
});
var SearchIcon = function SearchIcon() {
  var classes = useStyles();
  return /*#__PURE__*/_jsx(Icon, {
    className: "far fa-search ".concat(classes.searchIcon)
  });
};
var SearchField = function SearchField(_ref) {
  var onSearch = _ref.onSearch,
    className = _ref.className,
    textfieldProps = _objectWithoutProperties(_ref, _excluded);
  var _React$useState = React.useState(""),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    searchValue = _React$useState2[0],
    setSearchValue = _React$useState2[1];
  var classes = useStyles();
  return /*#__PURE__*/_jsx(TextField, _objectSpread({
    value: searchValue,
    onChange: function onChange(e) {
      setSearchValue(e.target.value);
      onSearch(e.target.value);
    },
    prefix: /*#__PURE__*/_jsx(SearchIcon, {}),
    variant: "standard",
    InputProps: {
      disableUnderline: true
    },
    className: classNames(classes.searchField, className)
  }, textfieldProps));
};
export default SearchField;